const getRoleQuery = () => {
  const query = `
    query MyQuery {
        getRoleJwt
      }`;
  return query;
};

export { getRoleQuery };
